{
  "taxes-and-prorations": "Impuestos y Prorrateos",
  "basic": "Básico",
  "tax": "Impuesto",
  "name": "Nombre",
  "prorate-using": "Prorratear Usando",
  "installment-amount": "Monto de la Cuota",
  "per-diem": "Por Día",
  "days-per-year": "Días por Año",
  "seller": "Vendedor",
  "buyer": "Comprador",
  "per-diem-decimals": "Decimales por día",
  "pull-tax-to-impound-disclosure": "Retirar impuestos para ncautar la divulgación",
  "include-1099": "Incluir en 1099",
  "tax-info": "Información Fiscal",
  "parcel-id": "ID Terreno",
  "paid-thru": "Pagado Hasta",
  "next-due": "Próximo Pago",
  "payment-schedule": "Pago Programado",
  "annual": "Anual",
  "quaterly": "Trimestral",
  "monthly": "Mensual",
  "other": "Otro",
  "proration": "Prorrateo",
  "installment-start-date": "Fecha de Inicio del Plazo",
  "proration-date": "Fecha de Prorrateo",
  "installment-end-date": "Fecha de Finalización del Plazo",
  "number-of-days-in-period": "Number of Days in Period",
  "days-year": "Dias por Año",
  "debited-party": "Parte Debitada",
  "buyer-owes-seller": "El Comprador Debe al Vendedor",
  "seller-owes-buyer": "El Vendedor Debe al Comprador",
  "prorated-amount":"Monto prorrateado"
}
